<template>
    <div class="loading-component">
        <icon type="solid" name="faSpinner" aria-hidden="true" focusable="false" spin></icon>
        <div v-if="loadingMessage" class="message">
            <span>{{ loadingMessage }}</span>
        </div>
    </div>
</template>

<script>
import script from './Loading';
    export default script;</script>

<style lang="less">
    @import "./Loading.less";
</style>